import React, { useState, useEffect } from "react";
import { SettlementBreakdownComponent } from "../billing/settlement/breakdown";
import { useSelector, useDispatch } from "react-redux";
import { clearCreated } from "../../redux/modules/settlement";

const SettlementCreatedComponent = () => {
  const [settlement, setSettlement] = useState(null);
  const settlementFromStore = useSelector(
    (state) => state.settlement.lastModified
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (settlementFromStore) {
      setSettlement(settlementFromStore);
    }
  }, [settlementFromStore]);

  const onClose = () => dispatch(clearCreated());

  if (!settlement) {
    return null;
  }

  return (
    <SettlementBreakdownComponent settlement={settlement} onClose={onClose} />
  );
};

export const DisplayCreatedSettlement = SettlementCreatedComponent;
